import React, { useEffect, useContext, useState } from 'react';
import clsx from 'clsx';
import { cloneDeep } from 'lodash';

import '../../../../common/ItemsList.css'

import {
    AvatarSkeleton,
    ContainedIconButton,
    FieldError,
    ImageRowList,
    UploadDialog,
    UploadFile,
} from '../../../../common';

import { v4 as uuidv4 } from 'uuid';

import {
    Form,
    Formik,
    Field
} from 'formik';

import {
    TextField,
    CheckboxWithLabel,
    Select
} from 'formik-material-ui';

import {
    Avatar,
    Badge,
    Button,
    CircularProgress,
    Dialog,
    Grid,
    IconButton,
    InputLabel,
    FormControl,
    MenuItem,
    Paper,
    Typography
} from '@material-ui/core';

import { ToastContext } from '../../../../contexts';
import { PageContext } from '../../PageContext';

import { ImageType, MaxFileSize } from '../../../../../helpers';

import { useTranslation } from "react-i18next";

import { BaseMenuItem } from './BaseMenuItem';

import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/core/styles';
const avatarSize = 90;
const useStyles = makeStyles((theme) => ({
    root: {
    },
    avatarSkeleton: {
        width: avatarSize,
        height: avatarSize,
        borderRadius: "50%",
        backgroundColor: "#CCCCCC",
        boxShadow: "rgb(0 0 0 / 30%) 0px 0px 5px 0px inset",
    },
    avatar: {
        width: avatarSize,
        height: avatarSize
    },
    title: {
        fontSize: "1.2em"
    },
    content: {
        marginTop: theme.spacing(4)
    },
    field: {
        width: "100%"
    },
    formControl: {
        width: '100%'
    },
    progress: {
        color: "black"
    },
    pickerBox: {
        marginLeft: "-6px"
    },
    imagesList: {
        display: "flex", marginTop: 16, paddingBottom: 16, overflowX: "auto", flexWrap: "nowrap"
    }
}));

const imageSourceOptions = [
    { label: "Images", value: "images" },
    { label: "Url", value: "url" },
]

const mode = [
    { label: "Overlay", value: "overlay" },
    { label: "Scenario", value: "scenario" },
    { label: "Overlay & Scenario", value: "all" }
]

const isHelpPageAbsoluteUrlOptions = [
    { label: 'URL', value: true },
    { label: 'Wordpress page', value: false }
]

export const PhotoEditorMenuItem = ({
    item,
    icons,
    formRef,
    errors,
    validationSchema,
    disabled,
    upload,
    onUpdated,
    onRemove,
    onSubmit,
    ...props }) => {
    const classes = useStyles();
    const theme = useTheme();

    const { t } = useTranslation();

    const {
        state
    } = useContext(PageContext);

    const {
        pages,
    } = state;

    const {
        showWarningMessage
    } = useContext(ToastContext);

    const getImagesOptions = (type = "") => {
        if (item.props.images)
            return item.props.images.filter(x => x.type === type);
        return [];
    }

    const removeImage = async (image) => {
        formRef.current.setFieldValue("props.images", cloneDeep(formRef.current.values.props.images).filter(x =>
            x.thumbnailUrl !== image.thumbnailUrl &&
            x.imageUrl !== image.imageUrl)
        );
    }

    const fileDropHandler = (imageType, file) => {
        if (file.type.includes('image')
            && file.name.endsWith(".png")) {
            if (file.size <= MaxFileSize.Max5MB) {
                return true;
            } else {
                showWarningMessage(t("MessageWrongFileSize5"));
                return false;
            }
        } else {
            showWarningMessage(t("MessageWrongImageFormat"));
            return false;
        }
    }

    const uploadfileAsync = async (imageType, data, file, type) => {
        if (upload) {
            const storedImageInfo = await upload(imageType, data, file);
            if (storedImageInfo !== null) {
                formRef.current.setFieldValue("props.images", [...cloneDeep(formRef.current.values.props.images), {
                    type: type, imageUrl: storedImageInfo.publicUrl, thumbnailUrl: storedImageInfo.publicThumbnailUrl
                }]);
                return true;
            }
        }
        return false;
    }

    const [openUploadOverlayDialog, setOpenUploadOverlayDialog] = useState(false);
    const [openUploadScenarioDialog, setOpenUploadScenarioDialog] = useState(false);

    const uploadOverlayImageHandler = async (data, file) => {
        const result = await uploadfileAsync(ImageType.PhotoEditor, data, file, "overlay");
        setOpenUploadScenarioDialog(false);
        return result;
    }

    const uploadScenarioImageHandler = async (data, file) => {
        const result = await uploadfileAsync(ImageType.PhotoEditor, data, file, "scenario");
        setOpenUploadOverlayDialog(false);
        return result;
    }

    return <BaseMenuItem
        item={item}
        icons={icons}
        formRef={formRef}
        errors={errors}
        validationSchema={validationSchema}
        disabled={disabled}
        upload={upload}
        onUpdated={onUpdated}
        onRemove={onRemove}
        onSubmit={onSubmit}>
        <Grid item xs={12}>
            <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel >{t("LabelImageSource")}</InputLabel>
                <Field
                    className={classes.field}
                    name="props.imageSource"
                    label={t("LabelImageSource")}
                    component={Select}
                    disabled={disabled}>
                    {imageSourceOptions.map(option =>
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>)}
                </Field>
            </FormControl>
            <FieldError
                name={`[${item.id}].imageSource`}
                errors={errors}
            />
        </Grid>
        {item.props.imageSource === "url" && <Grid item xs={12}>
            <Field
                className={classes.field}
                name="props.jsonUrl"
                type="text"
                variant="outlined"
                label={t("LabelJsonUrl")}
                component={TextField}
                disabled={disabled}
            />
            <FieldError
                name={`[${item.id}].props.jsonUrl`}
                errors={errors}
            />
        </Grid>}
        {item.props.imageSource === "images" &&
            <Grid item xs={12}>
                <FormControl variant="outlined" className={classes.formControl}>
                    <InputLabel >{t("LabelMode")}</InputLabel>
                    <Field
                        className={classes.field}
                        name="props.mode"
                        label={t("LabelMode")}
                        component={Select}
                        disabled={disabled}>
                        {mode.map(option =>
                            <MenuItem
                                key={option.value}
                                value={option.value}>
                                {option.label}
                            </MenuItem>)}
                    </Field>
                </FormControl>
                <FieldError
                    name={`[${item.id}].props.mode`}
                    errors={errors}
                />
            </Grid>}
        {item.props.imageSource === "images" &&
            <Grid item xs={12}>
                <FormControl variant="outlined" className={classes.formControl}>
                    <InputLabel >{t("LabelHelpPageLinkType")}</InputLabel>
                    <Field
                        className={classes.field}
                        name="props.isHelpPageAbsoluteUrl"
                        label={t("LabelHelpPageLinkType")}
                        component={Select}
                        disabled={disabled}>
                        {isHelpPageAbsoluteUrlOptions.map(option =>
                            <MenuItem
                                key={option.value}
                                value={option.value}>
                                {option.label}
                            </MenuItem>)}
                    </Field>
                </FormControl>
                <FieldError
                    name={`[${item.id}].props.isHelpPageAbsoluteUrl`}
                    errors={errors}
                />
            </Grid>}
        {item.props.imageSource === "images" &&
            (item.props.isHelpPageAbsoluteUrl ?
                <Grid item xs={12}>
                    <Field
                        className={classes.field}
                        name="props.helpPageUrl"
                        type="text"
                        variant="outlined"
                        label={t("LabelHelpPageLink")}
                        component={TextField}
                        disabled={disabled}
                    />
                    <FieldError
                        name={`[${item.id}].props.helpPageUrl`}
                        errors={errors}
                    />
                </Grid>
                :
                <Grid item xs={12}>
                    <FormControl variant="outlined" className={classes.formControl}>
                        <InputLabel>{t("LabelSelectPage")}</InputLabel>
                        <Field
                            className={classes.field}
                            name="props.helpPageWpUrl"
                            label={t("LabelSelectPage")}
                            component={Select}
                            disabled={disabled}>
                            {pages.map(option =>
                                <MenuItem
                                    key={option.link}
                                    value={option.link}>
                                    {option.slug}
                                </MenuItem>)}
                        </Field>
                    </FormControl>
                    <FieldError
                        name={`[${item.id}].props.helpPageWpUrl`}
                        errors={errors}
                    />
                </Grid>)}
        {item.props.imageSource === "images" && (item.props.mode === "overlay" || item.props.mode === "all") && <Grid item xs={12}>
            <Button
                onClick={() => setOpenUploadOverlayDialog(true)}
                color="primary"
                size="small"
                variant="contained">
                {t("ButtonUploadOverlay")}
            </Button>
            <ImageRowList images={getImagesOptions("overlay")} size={avatarSize} imagePropName="thumbnailUrl" removeImageHandler={removeImage} />
        </Grid>}
        {item.props.imageSource === "images" && (item.props.mode === "scenario" || item.props.mode === "all") && <Grid item xs={12}>
            <Button
                onClick={() => setOpenUploadScenarioDialog(true)}
                color="primary"
                size="small"
                variant="contained">
                {t("ButtonUploadScenario")}
            </Button>
            <ImageRowList images={getImagesOptions("scenario")} size={avatarSize} imagePropName="thumbnailUrl" removeImageHandler={removeImage} />
        </Grid>}


        <UploadDialog
            open={openUploadOverlayDialog}
            handleClose={() => setOpenUploadOverlayDialog(false)}
            disabled={disabled}
            titleText={t("TitleUploadOverlayImages")}
            helpText={t("LabelUploadHelp")}
            uploadButtonText={t("LabelUploadFile")}
            removeButtonText={t("LabelRemoveFile")}
            removeAllButtonText={t("LabelRemoveAllFiles")}
            onFileDropHandler={(files) => fileDropHandler(ImageType.PhotoEditor, files[0])}
            uploadHandler={uploadOverlayImageHandler}
        />
        <UploadDialog
            open={openUploadScenarioDialog}
            handleClose={() => setOpenUploadScenarioDialog(false)}
            disabled={disabled}
            titleText={t("TitleUploadScenarioImages")}
            helpText={t("LabelUploadHelp")}
            uploadButtonText={t("LabelUploadFile")}
            removeButtonText={t("LabelRemoveFile")}
            removeAllButtonText={t("LabelRemoveAllFiles")}
            onFileDropHandler={(files) => fileDropHandler(ImageType.PhotoEditor, files[0])}
            uploadHandler={uploadScenarioImageHandler}
        />
    </BaseMenuItem >
}